import { Box, Divider, Typography } from "@mui/material"
import GoogleLoginButton from '../../services/auth/GoogleLoginButton'

export default function LoginPage() {

    const styles = {
        root: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap-reverse',
            m: 0,
            p: 0,
            gap: 1,
            height: '100vh',
            fontFamily: 'Catamaran',
            backgroundColor: 'primary.main',
        },
        left: {
            flex: 3,
            color: 'text.regular',
            m: 1,
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        },
        right: {
            flex: 2,
            backgroundColor: 'primary.bg',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
        },
        loginContainer: {
            m: 1,
            p: '4vw',
            borderRadius: '20px',
        },
        heading: {
            fontWeight: 900,
            fontFamily: 'inherit',
            textAlign: 'center',
        },
        subheading: {
            fontWeight: 500,
            fontFamily: 'inherit',
            textAlign: 'center',
        },
        loginTitle: {
            fontWeight: 700,
            fontFamily: 'inherit',
            textAlign: 'center',
        },
        loginSubtitle: {
            fontWeight: 400,
            fontFamily: 'inherit',
            textAlign: 'center',
        },
        loginOptions: {
            display: 'flex',
            flexDirection: 'column',
            m: 2,
            p: 1,
            gap: 2,
        },
        termsLinks: {
            color: '#ff1493',
        }
    }

    return (
        <>
            <Box sx={styles.root}>
                {/* Left */}
                <Box sx={styles.left}>
                    <Typography variant="h1" component="h1" sx={styles.heading}>
                        Vibio
                    </Typography>
                    <Typography variant="h6" component="h6" sx={styles.subheading}>
                        video link in bio
                    </Typography>
                </Box>

                {/* Right */}
                <Box sx={styles.right}>
                    <Box sx={styles.loginContainer}>
                        <Typography variant="h4" component="h4" sx={styles.loginTitle}>
                            Welcome to Vibio
                        </Typography>
                        <Typography variant="body1" component="p" sx={styles.loginSubtitle}>
                            Let's get you started
                        </Typography>

                        <Box sx={styles.loginOptions}>
                            <GoogleLoginButton />
                            <p>More Sign in options coming soon</p>
                        </Box>

                        <Divider />

                        <center>
                            <p>
                                by continuing you agree to our
                                <br />
                                <a href='/terms' style={styles.termsLinks}>Terms</a> &{' '}
                                <a href='/privacy' style={styles.termsLinks}>Privacy</a>
                            </p>
                        </center>
                    </Box>
                </Box>
            </Box>
        </>
    )
}
